import React from 'react'
import Interview_Swiper from './Interview_Swiper'
import AutoplaySwi from '../../AutoplaySwi'
import VerticalSlider from './VerticalSlider'


const InterviewPrep = () => {
  return (
    <>

        <h1 className="ip_heading">
          <span>Interview </span>Preperation
        </h1>

        <div className="ip_banner">
          <img className="ip_banner_img" src="image/Interview/banner.webp" alt="" />
        </div>




        <div>

          <AutoplaySwi

              img1="image/Interview/AutoSwi1/1.webp"
              alt1="top dsa interview questions with solutions"

              img2="image/Interview/AutoSwi1/2.webp"
              alt2="rat in a maze problem with solution"

              img3="image/Interview/AutoSwi1/4.webp"
              alt3="house robber dsa problem with solution"

              img4="image/Interview/AutoSwi1/3.webp"
              alt4="valid parenthesis important dsa interview questions"

              img5="image/Interview/AutoSwi1/5.webp"
              alt5="minimize cash flow interview questions with solution"

              img6="image/Interview/AutoSwi1/6.webp"
              alt6="number of islands problem dsa with solution"
              
          />
          
        </div>




          <VerticalSlider
              href1="https://drive.google.com/file/d/1bbs_bQuDcN0LhasOLNNjydt7k-v1NA7U/view?usp=drivesdk"
              href2="https://drive.google.com/file/d/1c3yr6GRJDz84fzxyHtZb56oFrTM_i5sj/view?usp=drivesdk"
              href3="https://drive.google.com/file/d/1aWyeqRheyoIlRTyxMTOke7k7Lgh78tjl/view?usp=drivesdk"

              //for images
              src1="image/Interview/Interview_top_ques/dsa-must.webp"
              src2="image/Interview/Interview_top_ques/common-interview-questions.webp"
              src3="image/Interview/Interview_top_ques/Leetcode.webp"

              alt1="dsa 100 must do questions with solutions for interview preperation"
              alt2="interview questions with answers, tell me about yourself, why do u want to join this company"
              alt3="leetcode top 50 interview questions with solutions"
          />

        <div className="interview_content_boxes">
          <h2  className='in_heading'>Top Interview Questions</h2>
            <Interview_Swiper

                  src1="image/Roadmap/react.webp"
                  link1="https://drive.google.com/file/d/1XJeEi1l_1lKCmdX-T1WaCxNPtRiIBTUZ/view?usp=drivesdk"
                  alt1="react js developer top interview questions with solution"
                  
                  src2="image/Roadmap/node.webp"
                  link2="https://drive.google.com/file/d/1a8t9UhqD1TQf89NcJaQrm_3M6mDDcPmD/view?usp=drivesdk"
                  alt2="node developer interview questions with solutions"

                  src3="image/Roadmap/mysql.webp"
                  link3="https://drive.google.com/file/d/1XKmxxSA-v65maVoCUX9-Zqlhd43f0ZAa/view?usp=drivesdk"
                  alt3="mysql backened interview questions"

                  src4="image/Roadmap/frontend.webp"
                  link4=""
                  alt4="frontend developer interview questions with answers"

                  src5="image/Roadmap/backend.webp"
                  link5=""
                  alt5="backened developer interview questions with answers"

                  
                  
            />


            <Interview_Swiper
                src1="image/Roadmap/java.webp"
                link1="https://drive.google.com/file/d/1aBdhZRvf4QqF3KWHP5bbdrnUivASXx7p/view?usp=drivesdk"
                alt1="java interview questions with solution pdf"

                src2="image/Roadmap/cpp.webp"
                link2="https://drive.google.com/file/d/1_7xH1GGm1-TZACeE0icl_KA8Jncji08L/view?usp=drivesdk"
                alt2="cpp c++ interview questions with solutions"

                src3="image/Roadmap/python.webp"
                link3="https://drive.google.com/file/d/1XJeEi1l_1lKCmdX-T1WaCxNPtRiIBTUZ/view?usp=drivesdk"
                alt3="python developer interview questions with answers"

                src4="image/Roadmap/js.webp"
                link4="https://drive.google.com/file/d/1aDABh7T75li6Dnh2NFWKfu--tvWLOWxE/view?usp=drivesdk"
                alt4="java script developer top asked interview questions with solutions"

                src5="image/Interview/interview_top_ques/oops.webp"
                link5="https://drive.google.com/file/d/1_9k0aevMP2IFuJxIi7DCC54YsbWfoDCG/view?usp=drivesdk"
                alt5="oops class inheritance interview question pdf"
            
            />



        </div>


        <AutoplaySwi
              img1="image/Interview/AutoSwi1/a.webp"
              alt1="cpp cheat sheet pdf"
              img2="image/Interview/AutoSwi1/b.webp"
              alt2="cpp control flow , while loop, switch loop, for loop pdf"
              img3="image/Interview/AutoSwi1/c.webp"
              alt3="input and output using c language"
              img4="image/Interview/AutoSwi1/d.webp"
              alt4="data types and operators using c language"
              img5="image/Interview/AutoSwi1/e.webp"
              alt5="libraries using c and c++ language"
              img6="image/Interview/AutoSwi1/a.webp"
              alt6="cheat sheets for interview perperation"
          />


        <VerticalSlider
            //this is for a href
            href1="https://drive.google.com/file/d/1btlybqyTbtIYzdqX4--vxttyfVHDThQI/view?usp=drivesdk"
            href2="https://drive.google.com/file/d/1bpp1EoN2QmkXpHnEzFSFWOvJk5HTWQKy/view?usp=drivesdk"
            href3="https://drive.google.com/file/d/1Yo8kVbgRIn0pwbsMYbOoqRITSUpYJjfL/view?usp=drivesdk"

            //this is for images
            src1="image/Interview/cheat_sheets/Vscode.webp"
            src2="image/Interview/cheat_sheets/git-commands.webp"
            src3="image/Interview/cheat_sheets/dsa-cheat-sheet.webp"
            
            alt1="vscode shortcuts cheat sheets for interview preperation"
            alt2="git commands cheat sheets for interview "
            alt3="data structure and algorithm complete interview preperation cheat sheet"
        />


        <div className="interview_content_boxes">
          <h2  className='in_heading'>Cheat Sheets</h2>
            <Interview_Swiper

                  src1="image/Interview/cheat_sheets/git.webp"
                  link1="https://drive.google.com/file/d/1YZAVOVXNL-Essj-3AMMgyyrJMUnS8RuN/view?usp=drivesdk"
                  alt1="git cheat sheets for interview preperation"

                  src2="image/Interview/cheat_sheets/datascience.webp"
                  link2="https://drive.google.com/file/d/1YVQvD3htjnwRNfatgzn44b4ERjkqb--C/view?usp=drivesdk"
                  alt2="data science cheat sheets for interview"

                  src3="image/Interview/cheat_sheets/python.webp"
                  link3="https://drive.google.com/file/d/1YZGr-PhnyOjtAG8VOvp4oI1K_9caZ7Y6/view?usp=drivesdk"
                  alt3="complete python course pdf"

                  src4="image/Interview/cheat_sheets/css.webp"
                  link4="https://drive.google.com/file/d/1YV7FcHF85xv3FQ-RKiLXJ1YQQP0ohvk4/view?usp=drivesdk"
                  alt4="css short notes pdf cheat sheets"

                  src5="image/Roadmap/js.webp"
                  link5="https://drive.google.com/file/d/1YYihFiXf1Iwqq7tYp_autfeUCIxqLY8T/view?usp=drivesdk"
                  alt5="javascript complete notes pdf"

                  src6="image/Roadmap/mondb.webp"
                  link6="https://drive.google.com/file/d/1Yv64opiFwPk5-co699GuJmmx0e-4XjJ5/view?usp=drivesdk"
                  alt6="mongodb short notes pdf"
            />
            <Interview_Swiper
                  src1="image/Roadmap/dsa.webp"
                  link1="https://drive.google.com/file/d/1Yo8kVbgRIn0pwbsMYbOoqRITSUpYJjfL/view?usp=drivesdk"
                  alt1="dsa short notes pdf for interview"

                  src2="image/Roadmap/cpp.webp"
                  link2="https://drive.google.com/file/d/1YjvcPDHCWM9sn8rnVB6uZ4-S7kb3edYv/view?usp=drivesdk"
                  alt2="cpp or c++ short notes for interview"

                  src3="image/Roadmap/java.webp"
                  link3="https://drive.google.com/file/d/1YRhnOeHXuoVg6GAh4n6rA1CspjG-ZFET/view?usp=drivesdk"
                  alt3="java cheat sheets for interview pdf"

                  src4="image/Interview/interview_top_ques/oops.webp"
                  link4="https://drive.google.com/file/d/1YkdymuZmQF9pwQe_A32DzdkCwyKkoAxE/view?usp=drivesdk"
                  alt4="oops short notes for interview"

                  src5=""
                  link5=""
                  alt5=""
                  
                  src6="image/Roadmap/Datastructure.webp"
                  link6=""
                  alt6=" datastructure notes for interview preperations"
            />

        </div>


        <div className="interview_content_boxes">
          <h2  className='in_heading'>Top Interview Tips</h2>
            <Interview_Swiper
                  src1="image/Roadmap/react.webp"
                  alt1=""
                  src2="image/Roadmap/node.webp"
                  src3="image/Roadmap/dsa.webp"
                  src4="image/Roadmap/frontend.webp"
                  src5="image/Roadmap/backend.webp"
            />
            <Interview_Swiper
                src1="image/Roadmap/java.webp"
                src2="image/Roadmap/cpp.webp"
                src3="image/Roadmap/python.webp"
                src4="image/Roadmap/js.webp"
                src5="image/Roadmap/Datastructure.webp"
            />

        </div>


        <div className="common_job_ques_banner">
              <a href="https://drive.google.com/file/d/1c7vdEsoXO7FqBV13QfcM3kbYnoAHbdEf/view?usp=drivesdk">
                <img className="common_job_ques" src="image/Interview/common-job-interview-questions.webp" alt="basic interview questions with solutions pdf, tell me about yourself, strength, weakness, where do you see yourself in next five years" />
              </a>
        </div>

    
    
    
    </>
  )
}

export default InterviewPrep